import logoImpactools from "../../assets/img/logosImpactools/logoImpactools.svg"
import SuccessIcon from "../../assets/icons/success.svg"
import { RadioButton } from "../../components/RadioButton"
import "./styles.scss"

export const EvaluationButton = ({ id, emoji, label, selectedOption, handleChange }) => (
  <div
    className={`evaluation-content-buttons-item ${selectedOption === id ? 'selected' : ''}`}
    onClick={() => handleChange(id)}
  >
    <RadioButton
      id={id}
      name={id}
      value={id}
      checked={selectedOption === id}
      className={"with-hover"}
      // onChange={(e) => handleChange(e.target.id)}
    />
    <div className="evaluation-content-buttons-item-text">
      {emoji}
      <span>{label}</span>
    </div>
  </div>
);

const SuccessMessage = ({ resetEvaluation }) => (
  <div className="evaluation-content-success">
    <div className="icon">
      <img src={SuccessIcon} alt="Success"/>
    </div>
    <span>Agradecemos sua avaliação!</span>
    {/* <button onClick={resetEvaluation}>Voltar para o whatsapp</button> */}
  </div>
);

const EvaluationAssistanceScreen = ({selectedOption, handleChange, resetEvaluation, success}) => {

  return (
    <div className="evaluation-container">
      <div className="evaluation-content">
        {selectedOption === '' ? (
          <>
            <div className="evaluation-content-logo">
              <div className="login-logo" style={{ backgroundImage: `url(${logoImpactools})` }}></div>
            </div>
            <div className="evaluation-content-buttons">
              <EvaluationButton
                id="1"
                emoji="😞"
                label="Muito Ruim"
                selectedOption={selectedOption}
                handleChange={handleChange}
              />
              <EvaluationButton
                id="2"
                emoji="😕"
                label="Ruim"
                selectedOption={selectedOption}
                handleChange={handleChange}
              />
              <EvaluationButton
                id="3"
                emoji="😐"
                label="Regular"
                selectedOption={selectedOption}
                handleChange={handleChange}
              />
              <EvaluationButton
                id="4"
                emoji="🙂"
                label="Bom"
                selectedOption={selectedOption}
                handleChange={handleChange}
              />
              <EvaluationButton
                id="5"
                emoji="😃"
                label="Muito Bom"
                selectedOption={selectedOption}
                handleChange={handleChange}
              />
            </div>
          </>
        ) : (
          <SuccessMessage resetEvaluation={resetEvaluation} />
        )}
      </div>
    </div>
  );
};

export default EvaluationAssistanceScreen;
